function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.875 16v-3.75m0-7.5V1M1 2.875h3.75M1 14.125h3.75M9.25 1.75l-1.3 3.382c-.212.55-.318.825-.482 1.056a2.25 2.25 0 01-.53.53c-.231.164-.506.27-1.056.481L2.5 8.5l3.382 1.3c.55.212.825.318 1.056.482.205.146.384.325.53.53.164.232.27.506.481 1.056L9.25 15.25l1.3-3.382c.212-.55.318-.825.482-1.056.146-.205.325-.384.53-.53.232-.164.506-.27 1.056-.481L16 8.5l-3.382-1.3c-.55-.212-.825-.318-1.056-.482a2.249 2.249 0 01-.53-.53c-.164-.231-.27-.506-.481-1.056L9.25 1.75z",
  stroke: "#2F80ED",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));